export default __webpack_public_path__ + "static/Mail-HeroSection-b14d9efe028a650420a210e2fdfb5f55.svg";